import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-bc0a2474"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "privacy"
};

const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"top-back\" data-v-bc0a2474><div class=\"left-top\" data-v-bc0a2474></div><div class=\"left-bottom\" data-v-bc0a2474></div><div class=\"right-mid\" data-v-bc0a2474></div><div class=\"right-bottom\" data-v-bc0a2474></div><div class=\"big-title\" data-v-bc0a2474> 小圈平台 <span class=\"text-color\" data-v-bc0a2474>违规公告</span></div><div class=\"title-desc\" data-v-bc0a2474><div class=\"short-line\" data-v-bc0a2474></div> 共同打造健康积极网络环境 <div class=\"short-line\" data-v-bc0a2474></div></div></div>", 1);

const _hoisted_3 = {
  class: "word-main"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-word"
}, [/*#__PURE__*/_createTextVNode(" 为响应国家扫黄净网的政策和精神，平台积极配合政策打击： "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 1、利用互联网制作传播淫秽色情信息的不良行为 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 2、平台内涉嫌色情低俗的内容 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 3、反动、诈骗等违法信息及内容 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 一经核实我们绝不姑息，将视情节严重情况对违规用户予以警告、限制账号权限、永久冻结封停等处理。只为了给用户提供一个绿色健康的交友环境。希望用户严格遵守平台守则，做一个高素质的人。 ")], -1));

const _hoisted_5 = {
  class: "top-word"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "name-title"
}, "封禁违规账号名单(展示最近50条)", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "list-back title-list"
}, [/*#__PURE__*/_createElementVNode("span", null, "用户昵称"), /*#__PURE__*/_createElementVNode("span", {
  class: "list-center"
}, "处罚时间"), /*#__PURE__*/_createElementVNode("span", {
  class: "list-right"
}, "处理方式")], -1));

const _hoisted_8 = {
  class: "list-out"
};
const _hoisted_9 = {
  class: "list-center"
};
const _hoisted_10 = {
  class: "list-out list-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass({
        'list-back': true,
        'title-list': true,
        'item-back': index % 2 === 0
      }),
      key: index
    }, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_9, _toDisplayString($setup.toDay(item.createTime)), 1), _createElementVNode("span", _hoisted_10, _toDisplayString($setup.toType(item.type, item.count)), 1)], 2);
  }), 128))])])]);
}